<template>
    <div>
        <div class="form-container ou-donation-form ncsysummer-donation-form">
            <div class="holder">
                <PaymentForm class="form-horizontal">
                    <FormSection title="Donation Amount">
                        <div>
                            <AmountSelector/>
                            <ErrorLabel field="amount" />
                        </div>
                    </FormSection>
                    <FormSection title="Your Contact Information">
                        <FormRow inline>
                            <FormCol simpleTitle="true" field="title" :flex="1" />
                            <FormCol field="firstName" :flex="2" />
                            <FormCol field="lastName" :flex="2" />
                        </FormRow>
                        <FormRow inline>
                            <FormCol field="email" />
                            <FormCol field="phone" />
                        </FormRow>
                        <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>                               
                    </FormSection>
                    <FormSection title="Billing Information">
                        <DonorAddress />
                    </FormSection>
                    <FormSection title="Payment Info" last>
                        <FormRow inline>
                            <FormCol field="card" :showLabel="false" />
                        </FormRow>
                    </FormSection>
                    <PaymentButton showAmount btnText="Donate" />
                </PaymentForm>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { onMounted } from 'vue'
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'
import { queryParams } from '~/shared/query-params'

export default defineComponent({
  props: {
    subCampaign: String,
  },  setup(props) {
    const { setValue, form, submit } = usePaymentForm()

    if (props.subCampaign) {
      setValue('applications.0.subCampaign', props.subCampaign)
    }

    onMounted(() => {
      const params = queryParams()

      if (params.utm_content) {
        if (
          !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
            params.utm_content
          )
        ) {
          throw new Error('Invalid subcampaign')
        }

        setValue('applications.0.subCampaign', params.utm_content)
      }
    })

    
    return {
      form,
      submit,
      setValue
    }
  },
})
</script>

<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}

::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  @media (min-width: 720px) {
    min-width: 33.3%;
    flex: 1;
    max-width: 33.3%;
  }
}

.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width: 50%;
    max-width: 50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>
